import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PaymentMethodInput, SelectOptionItem } from '@cashier/cashier-model';

export interface PaymentFormState {
  paymentInputs: Record<string, PaymentMethodInput>;
  inputErrorMap: Record<string, string[]>;
  options: SelectOptionItem[];
  isFormReady: boolean;
}

export const PAYMENT_FORM_FEATURE_KEY = 'paymentForm';

export const initialPaymentFormState: PaymentFormState = {
  paymentInputs: {},
  inputErrorMap: {},
  options: [],
  isFormReady: false,
};

export const paymentFormSlice = createSlice({
  name: PAYMENT_FORM_FEATURE_KEY,
  initialState: initialPaymentFormState,
  reducers: {
    setPaymentInputs: (
      state,
      action: PayloadAction<Record<string, PaymentMethodInput>>,
    ) => {
      state.paymentInputs = action.payload;
    },
    setInputErrorMap: (
      state,
      action: PayloadAction<Record<string, string[]>>,
    ) => {
      state.inputErrorMap = action.payload;
    },
    fetchDirecta24OptionsStart: (
      state,
      action: PayloadAction<{
        url: string;
        parameters: Record<string, string>;
      }>,
    ) => undefined,
    fetchDynamicOptionsStart: (state, action: PayloadAction<{ url: string }>) =>
      undefined,
    fetchDynamicOptionsSuccess: (state, action: PayloadAction<any>) => {
      state.options = action.payload.map(
        ({ payerName }: { payerName: string }) => ({
          value: payerName,
          label: payerName,
        }),
      );
    },
    fetchDirecta24OptionsSuccess: (state, action: PayloadAction<any>) => {
      if (!action.payload.code) {
        state.options = action.payload.map(
          ({ code, name }: { code: string; name: string }) => ({
            value: code,
            label: name,
          }),
        );
      }
    },
    fetchDirecta24OptionsFailure: (state, action: PayloadAction<any>) =>
      undefined,
    setFormReady: (state, action: PayloadAction<boolean>) => {
      state.isFormReady = action.payload;
    },
    onInputBlur: (state, action: PayloadAction<{ fieldName: string }>) =>
      undefined,
  },
});

export const paymentFormReducer = paymentFormSlice.reducer;

export const {
  setPaymentInputs,
  setInputErrorMap,
  fetchDirecta24OptionsStart,
  fetchDirecta24OptionsSuccess,
  fetchDirecta24OptionsFailure,
  fetchDynamicOptionsStart,
  fetchDynamicOptionsSuccess,
  setFormReady,
  onInputBlur,
} = paymentFormSlice.actions;
